import React from 'react';

import { useHBPrimeData } from 'hb-redux-store/feature/halalboxPrime/hbPrime.hooks';
import { useInitialData } from 'hb-redux-store/initial.hooks';
import {
  ADD_TO_CART,
  BUY_NOW,
  MEMBERSHIP_ADDED,
  SELECT_MEMBERSHIP_PLAN,
  MEMBERSHIP_LOGIN_CTA,
} from 'hb-redux-store/constants/halalboxPrime';
import history from 'hb-redux-store/history';

import Button from 'components/common/Button/Button';
import { getCheckoutRoute } from 'components/web-feature/checkout/checkout.routes';

import './membership-cta.scss';
import { HB_PRIME_ROUTE } from 'components/web-feature/Home/constant';

const MembershipCTA = ({
  source = 'HOME',
  selectedPlan = {},
  containerStyle = '',
  onCancel = () => {},
}) => {
  const { addMembershipTocart } = useHBPrimeData();
  const {
    setAppNotification,
    initialData: { launchInfo },
  } = useInitialData();
  const { loggedIn } = launchInfo;
  const showDetails = {
    HOME: {
      showBuyButton: true,
      space: true,
      modalClose: false,
      redirectToCart: false,
    },
    CART: {
      showBuyButton: false,
      space: false,
      modalClose: true,
      redirectToCart: true,
    },
  };

  const successCb = ({ isBuyNow }) => {
    setAppNotification(MEMBERSHIP_ADDED);
    if (isBuyNow) {
      const paymentLink = getCheckoutRoute('payment');
      history.push(paymentLink);
    } else {
      if (showDetails[source]?.modalClose) {
        onCancel();
      } else {
        history.push('/cart');
      }
    }
  };

  const addMembershipToCart = ({ isBuyNow }) => {
    if (selectedPlan?.hbMembershipId) {
      const payload = {
        api: {
          hbMembershipId: selectedPlan?.hbMembershipId,
          isBuyNow,
        },
        successCb: () => successCb({ isBuyNow }),
      };
      addMembershipTocart(payload);
    } else {
      setAppNotification(SELECT_MEMBERSHIP_PLAN);
    }
  };
  return (
    <div className={containerStyle}>
      <div className="hb-prime-bottom-cta--container">
        <Button
          className={`hb-prime-button hb-prime-bottom-cta add-to-cart-button ${
            showDetails[source]?.space ? 'space-right' : ''
          }`}
          onClick={() => addMembershipToCart({ isBuyNow: false })}
        >
          {ADD_TO_CART}
        </Button>
        {showDetails[source]?.showBuyButton && (
          <Button
            className="hb-prime-button hb-prime-bottom-cta buy-now-button space-left"
            onClick={() => addMembershipToCart({ isBuyNow: true })}
          >
            {BUY_NOW}
          </Button>
        )}
      </div>
    </div>
  );
};

export default MembershipCTA;
